export const HEADER_STRINGS = {
    MyZodoc: 'My Zocdoc',
    PastAppointments: 'Past appointments',
};

export const PatientNavLinks = [
    {
        message: HEADER_STRINGS.MyZodoc,
        url: '/patient/medicalteam',
        dataTest: 'my-zocdoc',
    },
    {
        message: HEADER_STRINGS.PastAppointments,
        url: '/patient/pastappointments',
        dataTest: 'past-appointments',
    },
];
